import React from 'react';

const Select = ({
  label,
  name,
  options,
  value,
  onChange,
  required = false,
  isLoading = false,
}) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>{label} <span className="required-star">{required?'*':''}</span></label>
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        className="form-select"
        disabled={isLoading}
      >
        <option value="" disabled>
          {isLoading ? 'Loading...' : `Select ${label}`}
        </option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
